import * as React from 'react';
import { Avatar as AvatarPrimitive } from 'radix-ui';
import { cn } from './utils';

function Avatar({
  className,
  size = 'md',
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Root> & {
  size?: 'sm' | 'md' | 'lg' | 'xl';
}) {
  return (
    <AvatarPrimitive.Root
      data-slot="avatar"
      data-size={size}
      className={cn(
        'group/avatar relative flex size-9 shrink-0 overflow-hidden rounded-full select-none data-[size=lg]:size-11 data-[size=sm]:size-7 data-[size=xl]:size-14',
        className,
      )}
      {...props}
    />
  );
}

function AvatarImage({ className, ...props }: React.ComponentProps<typeof AvatarPrimitive.Image>) {
  return (
    <AvatarPrimitive.Image
      data-slot="avatar-image"
      className={cn('aspect-square size-full', className)}
      {...props}
    />
  );
}

function AvatarFallback({
  className,
  kind = 'initials',
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Fallback> & {
  /** `brand` stands in for an organisation with no photo: a tinted circle carrying its icon, never initials. */
  kind?: 'initials' | 'brand';
}) {
  return (
    <AvatarPrimitive.Fallback
      data-slot="avatar-fallback"
      data-kind={kind}
      className={cn(
        'flex size-full items-center justify-center rounded-full bg-muted text-caption text-muted-foreground group-data-[size=xl]/avatar:text-[18px] group-data-[size=xl]/avatar:leading-[18.2px] data-[kind=brand]:bg-primary-quiet data-[kind=brand]:text-primary-quiet-foreground',
        className,
      )}
      {...props}
    />
  );
}

function AvatarGroup({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="avatar-group"
      className={cn(
        'group/avatar-group flex -space-x-2 *:data-[slot=avatar]:ring-2 *:data-[slot=avatar]:ring-background',
        className,
      )}
      {...props}
    />
  );
}

export { Avatar, AvatarImage, AvatarFallback, AvatarGroup };
